import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";
import checkIcon from "../../resources/images/check-white.svg";
import minusIcon from "../../resources/images/faq-lep-minus.svg";
import plusIcon from "../../resources/images/faq-lep-plus.svg";

const styles = createUseStyles((theme) => ({
  fullPageModal: {
    padding: "0 !important",
    "& .modal-dialog": {
      maxWidth: "100%",
      margin: 0,
      height: "100%",
    },
    "& .modal-content": {
      minHeight: "100vh",
      borderRadius: 0,
      border: "none",
    },
    "& .modal-header": {
      justifyContent: "space-between",
      height: "72px",
      padding: "0px 112px",
      backgroundColor: colors.primary25Blue,
      borderBottom: "1px solid " + colors.primary300Blue,
      [`@media (max-width: ${breakpoints.lg}px)`]: {
        padding: "0px 60px",
      },
      [`@media (max-width: ${breakpoints.md}px)`]: {
        padding: "10px 20px",
        height: "auto",
      },
      "& div": {
        display: "flex",
        alignItems: "center",
        "& svg": {
          flexShrink: 0,
        },
      },
      "& h6": {
        margin: "0px 6px 0px 16px",
        fontSize: "16px",
        lineHeight: "24px",
        fontWeight: "600",
        color: colors.primary700Blue,
        [`@media (max-width: ${breakpoints.md}px)`]: {
          margin: 0,
        },
      },
      "& span": {
        fontSize: "16px",
        lineHeight: "24px",
        fontWeight: "400",
        color: colors.primary600Blue,
      },
    },
    "& .modal-body": {
      padding: 0,
    },
    "& .modal-backdrop": {
      top: "20px",
      zIndex: "1055",
      "--bs-backdrop-zindex": 1055,
    },
  },
  modalHeaderText: {
    display: "flex",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      flexDirection: "column",
      alignItems: "flex-start !important",
      margin: "0px 10px",
    },
  },
  bodyContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "100%",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      flexDirection: "column",
    },
  },
  leftPanel: {
    flex: "1 1 50%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: "0px 60px",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      padding: "60px",
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      padding: "30px 20px",
    },
    "& h2": {
      fontSize: "30px",
      fontWeight: "600",
      lineHeight: "38px",
      color: colors.lightBlack,
      marginBottom: "12px",
    },
    "& h5": {
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      color: colors.inactiveGrey,
      margin: "0px",
    },
  },
  radioWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    margin: "32px 0px",
    width: "100%",
  },
  rightPanel: {
    flex: "1 1 50%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: colors.gray25,
    borderRadius: "80px 0px 0px 80px",
    padding: "0px 32px 86px",
    maxHeight: "calc(100vh - 72px)",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      padding: "0px 60px 60px",
      borderRadius: 0,
      maxHeight: "fit-content",
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      padding: "0px 20px 30px",
      borderRadius: 0,
      maxHeight: "fit-content",
    },
    "& h1": {
      fontSize: "36px",
      fontWeight: "600",
      lineHeight: "44px",
      color: colors.lightBlack,
      margin: "96px 0px 64px 0px",
      [`@media (max-width: ${breakpoints.md}px)`]: {
        margin: "30px 0px",
      },
    },
  },
  radioContainerActive: {
    display: "flex",
    backgroundColor: colors.primary50Blue,
    outline: "2px solid " + colors.primary600Blue,
    borderRadius: "12px",
    padding: "14px",
    cursor: "pointer",
    "& input": {
      appearance: "none",
    },
  },
  radioContainer: {
    extend: "radioContainerActive",
    backgroundColor: colors.white,
    outline: "1px solid " + colors.lightGrey,
    "&:hover": {
      outline: theme.modal.optionHover.border,
      "& [class*='checkmark']":{
        backgroundColor: theme.modal.optionHover.backgroundColor,
        border: theme.buttons.primary.border,
      },
    },
  },
  icon: {
    flexShrink: 0,
    border: "1px solid" + colors.lightGrey,
    borderRadius: "8px",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    height: "40px",
    width: "40px",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center",
    "& svg": {
      height: "20px",
      width: "20px",
    },
  },
  radioTextActive: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    margin: "0px 16px",
    gap: "2px",
    "& h6": {
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "24px",
      color: colors.darkBlue,
      margin: "0px",
    },
    "& p": {
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      color: colors.darkBlue,
      margin: "0px",
    },
    "& div": {
      display: "inline-flex",
      alignItems: "center",
      "& span": {
        backgroundColor: "#EEF4FF",
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "18px",
        color: "#3538CD",
        padding: "2px 8px",
        marginLeft: "6px",
        borderRadius: "16px",
      },
    },
  },
  radioText: {
    extend: "radioTextActive",
    "& h6": {
      color: colors.grey,
    },
    "& p": {
      color: colors.mediumGrey,
    },
  },
  checkmark: {
    flexShrink: 0,
    marginLeft: "auto",
    height: "20px",
    width: "20px",
    border: "1px solid " + colors.darkGrey,
    borderRadius: "50%",
  },
  checkmarkChecked: {
    backgroundImage: `url(${checkIcon})`,
    backgroundColor: `${colors.primary600Blue} !important`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    border: "none",
    backgroundSize: "12px",
  },
  nextBtn: {
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "24px",
    padding: "10px 18px",
    border: "none",
    marginLeft: "auto",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    "& svg": {
      margin: "0px 0px 2px 8px",
      "& path": {
        stroke: colors.white,
      },
    },
  },
  faqWrapper: {
    height: "auto",
    width: "100%",
    marginBottom: "64px",
    overflowX: "hidden",
    overflowY: "auto",
    padding: "20px 0px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      marginBottom: "30px",
    },
  },
  accordion: {
    "--bs-accordion-border-color": "transparent",
    "--bs-accordion-border-width": "0px",
    "--bs-accordion-bg": "inherit",
    "& .accordion-item":{
      marginRight:"10px",
    },
    "& .accordion-body": {
      padding: "0px",
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      color: colors.mediumGrey,
    },
    "& .accordion-button": {
      backgroundColor: "inherit",
      padding: "0px",
      fontSize: "18px",
      fontWeight: "500",
      lineHeight: "28px",
      color: colors.lightBlack,
      marginBottom: "8px",
      alignItems: "flex-start",
      gap: "24px",
      "&:not(.collapsed)::after": {
        backgroundImage: `url(${minusIcon})`,
        content: '""',
        display: "inline-block",
        marginTop: "3px",
      },
      "&:after": {
        backgroundImage: `url(${plusIcon})`,
        content: '""',
        display: "inline-block",
        marginTop: "3px",
      },
      "&:focus": {
        outline: "none",
        boxShadow: "none",
      },
    },
  },
  divider: {
    color: colors.lightGrey,
    opacity: "1",
    margin: "32px 0px",
  },
  chatWrapper: {
    display: "flex",
    alignItems: "center",
    padding: "32px",
    backgroundColor: colors.white,
    borderRadius: "16px",
    width: "100%",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      padding: "10px",
    },
  },
  chatText: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    margin: "0px 32px 0px 16px",
    gap: "8px",
    "& h6": {
      fontSize: "20px",
      fontWeight: "600",
      lineHeight: "30px",
      color: colors.lightBlack,
      margin: "0px",
    },
    "& p": {
      fontSize: "18px",
      fontWeight: "400",
      lineHeight: "28px",
      color: colors.mediumGrey,
      margin: "0px",
    },
  },
  chatBtn: {
    border: "1px solid" + colors.darkGrey,
    borderRadius: "8px",
    textDecoration: "none",
    color: colors.grey,
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "24px",
    padding: "11px 19px",
    marginLeft: "auto",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
  },
  closeBtn: {
    cursor: "pointer",
  },
  iconActive:{
    "& path": {
      stroke: colors.darkBlue,
      fill: colors.primary100Blue,

    },
    "& rect":{
      fill: colors.primary100Blue,
      stroke: colors.primary50Blue,
    }
  },
  iconDisabled:{

  },
  assignDisabeld:{
    "& path": {
      stroke: colors.mediumGrey,
      fill: colors.gray100,

    },
    "& rect":{
      fill: colors.gray100,
      stroke:colors.brightBlue,
    }
  },
  closeIcon:{
    "&:hover":{
      "& path":{
        fill:colors.primary100Blue
      },
      "& rect":{
        fill:colors.primary100Blue,
        stroke: colors.primary100Blue
      }
    }
  }
}));

export default styles;
